import { createAsyncThunk } from "@reduxjs/toolkit"
import { isValidString } from "tools/strings/isNonEmptyString"
import { ClientConfigurationDetail } from "./constants"
import { selectClientApplicationId, selectIsInitializingClientApplication } from "./selectors"
import { RootState } from "integrations/redux"

export const initializeClientApplication = createAsyncThunk(
    "systems/initialize/clientApplication",
    async (_, thunkApi) => {
        const response = await fetch("/api/client")
        const data = (await response.json()) as ClientConfigurationDetail

        if (!(typeof data === "object" && data !== null) || Object.keys(data).length === 0) {
            return thunkApi.rejectWithValue(false)
        }

        const { applicationId, environmentName } = data
        if (isValidString(applicationId)) {
            return data
        }

        console.warn("Received invalid client application configuration data", {
            applicationId,
            environmentName,
        })

        return thunkApi.rejectWithValue(false)
    },
    {
        condition: (_, thunkApi) => {
            const state = thunkApi.getState() as RootState
            const canInitialize =
                !selectIsInitializingClientApplication(state) &&
                selectClientApplicationId(state) === undefined

            return canInitialize
        },
    }
)
